export interface ToasterInterface {
  show(message: string, duration: ToasterDuration): void;
}

export enum ToasterDuration {
  LONG,
  SHORT
}
